/* eslint-disable */
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Avatar,
  IconButton,
  Chip,
  Typography,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { CloudUpload, Delete as DeleteIcon } from '@mui/icons-material';
import { FirebaseContext } from 'common';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agent-tabpanel-${index}`}
      aria-labelledby={`agent-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const IndependantForm = ({
  onClose,
  onSubmit,
  sourceData,
  onPublishToPP,
  onPublishToWebsite,
  initialPublishMode,
}) => {
  const { api } = useContext(FirebaseContext) || {};
  const { AddP24, AddWebsite, AddBroker, EditBroker } = api || {};
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    Firebaseusertype: 'broker',
    id: '',
    agentId: '',
    websiteID: '',
    branchId: '',
    privysealAlias: '',
    registrationNumber: '',
    vatNumber: '',
    password: '',
    agencyId: 0,
    cityId: 123,
    sourceReference: '',
    mobileNumber: '',
    emailAddress: '',
    faxNumber: '',
    workNumber: '',
    qualification: '',
    fidelityFundCertificationYear: '',
    fidelityFundCertificationNumber: '',
    idNumber: '',
    incomeTaxNumber: '',
    about: '',
    licenseImage: null,
    brokerImage: null,
    countryId: 1,
    profilePicture: null,
    profile: { facebook: '', twitter: '' },
    status: 'Active',
    jobTitle: '',
  });

  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [tabValue, setTabValue] = useState(0);
  const [errors, setErrors] = useState({});
  const [publishChoice, setPublishChoice] = useState(initialPublishMode || 'none');

  useEffect(() => {
    if (sourceData) {
      setFormData((prev) => ({
        ...prev,
        ...sourceData,
        agencyId: sourceData?.agencyId,
        firstname: sourceData.firstname || sourceData.firstName || sourceData.name?.split(' ')[0] || '',
        lastname: sourceData.lastname || sourceData.lastName || sourceData.name?.split(' ')[1] || '',
        emailAddress: sourceData.emailAddress || sourceData.email || '',
        mobileNumber: sourceData.mobileNumber || sourceData.mobile || sourceData.phone || '',
        workNumber: sourceData.workNumber || sourceData.mobileNumber || sourceData.mobile || sourceData.phone || '',
        idNumber: sourceData.idNumber || sourceData.identityNumber || '',
      }));
      if (initialPublishMode) setPublishChoice(initialPublishMode);
    }
  }, [sourceData, initialPublishMode]);

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setErrors((prev) => ({ ...prev, [name]: '' }));
    if (type === 'checkbox') {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else if (name.startsWith('profile.')) {
      const profileField = name.split('.')[1];
      setFormData((prev) => ({
        ...prev,
        profile: { ...prev.profile, [profileField]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => setImagePreview(e.target.result);
    reader.readAsDataURL(file);

    const base64Reader = new FileReader();
    base64Reader.onload = (e) => {
      const base64 = e.target.result.split(',')[1];
      setFormData((prev) => ({
        ...prev,
        profilePicture: {
          bytes: base64,
          mimeContentType: file.type,
          caption: `Profile picture of ${prev.firstname} ${prev.lastname}`.trim() || 'Agent profile picture',
        },
      }));
    };
    base64Reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setImagePreview(null);
    setFormData((prev) => ({ ...prev, profilePicture: null }));
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+27\d{9}$/;
  const requiredByTab = {
    0: ['firstname', 'lastname', 'emailAddress', 'password', 'idNumber'],
    1: ['mobileNumber', 'workNumber'],
    3: ['profilePicture'],
  };

  const validateForTab = (tabIndex) => {
    const tabErrors = {};
    const fields = requiredByTab[tabIndex] || [];
    fields.forEach((f) => {
      const value = formData[f];
      if (!value || String(value).trim() === '') {
        tabErrors[f] = 'This field is required';
      } else {
        if (f === 'emailAddress' && !emailRegex.test(value)) {
          tabErrors[f] = 'Enter a valid email';
        }
        if (f === 'mobileNumber' && !phoneRegex.test(value)) {
          tabErrors[f] = 'Mobile must start with +27 and be 12 digits';
        }
        if (f === 'password' && value.length < 12) {
          tabErrors[f] = 'Password must be at least 12 characters long';
        }
      }
    });

    // Special validation for image on last tab
    if (tabIndex === 3 && fields.includes('profilePicture')) {
      if (!formData.profilePicture?.bytes) {
        tabErrors.profilePicture = 'Profile picture is required and must be uploaded.';
      }
    }

    return tabErrors;
  };

  const handleNext = async () => {
    const tabErrors = validateForTab(tabValue);
    if (Object.keys(tabErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...tabErrors }));
      const firstField = Object.keys(tabErrors)[0];
      const el = document.getElementsByName(firstField)[0];
      if (el && typeof el.focus === 'function') el.focus();
      else window.alert(`Please fill required fields: ${Object.keys(tabErrors).join(', ')}`);
      return;
    }

    // If on last tab, submit form
    if (tabValue === 3) {
      try {
        const formEvent = { preventDefault: () => {} };
        await handleSubmit(formEvent);
      } catch (err) {
        console.error('Submission failed:', err);
      }
    } else {
      setTabValue((v) => v + 1);
    }
  };

  const handleBack = () => setTabValue((v) => Math.max(v - 1, 0));

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && tabValue < 3) {
      e.preventDefault();
      handleNext();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Final validation before submit
    const finalErrors = validateForTab(3);
    if (Object.keys(finalErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...finalErrors }));
      window.alert('Please upload a profile picture and fill all required fields.');
      return;
    }

    try {
      if (publishChoice === 'pp') {
        if (AddP24) {
          await dispatch(AddP24(formData, formData.id || sourceData?.id));
        }
        if (onClose) onClose();
        return;
      }

      if (publishChoice === 'website') {
        if (AddWebsite) {
          await dispatch(AddWebsite(formData, formData.id || sourceData?.id));
        }
        if (onClose) onClose();
        return;
      }

    

      if (onClose) onClose();
    } catch (err) {
      console.error('Form submission error:', err);
      setErrors((prev) => ({ ...prev, submit: 'Failed to submit. Please try again.' }));
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
      <DialogTitle>
        {sourceData
          ? `Create Agent from ${sourceData.name || sourceData.firstname || 'Record'}`
          : 'Add New Agent'}
      </DialogTitle>

      <Tabs
        value={tabValue}
        sx={{ px: 3, mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
        onChange={handleTabChange}
      >
        <Tab label="Basic Info" />
        <Tab label="Contact Details" />
        <Tab label="Professional Info" />
        <Tab label="Profile & Image" />
      </Tabs>

      <DialogContent
        sx={{
          maxHeight: '70vh',
          overflow: 'auto',
          background: '#f9f9f9',
          borderRadius: 2,
          mt: 1,
        }}
      >
        {sourceData && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Prefilled from existing record
          </Typography>
        )}

        <TabPanel value={tabValue} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="firstname"
                label="First Name"
                fullWidth
                value={formData.firstname}
                onChange={handleChange}
                error={!!errors.firstname}
                helperText={errors.firstname}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="lastname"
                label="Last Name"
                fullWidth
                value={formData.lastname}
                onChange={handleChange}
                error={!!errors.lastname}
                helperText={errors.lastname}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="emailAddress"
                label="Email Address"
                type="email"
                fullWidth
                value={formData.emailAddress}
                onChange={handleChange}
                error={!!errors.emailAddress}
                helperText={errors.emailAddress}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="password"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                fullWidth
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
                required
                InputProps={{
                  endAdornment: (
                    <Button size="small" onClick={() => setShowPassword((v) => !v)}>
                      {showPassword ? 'Hide' : 'Show'}
                    </Button>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="idNumber"
                label="ID Number"
                fullWidth
                value={formData.idNumber}
                onChange={handleChange}
                error={!!errors.idNumber}
                helperText={errors.idNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="about"
                label="About"
                fullWidth
                multiline
                rows={3}
                value={formData.about}
                onChange={handleChange}
                error={!!errors.about}
                helperText={errors.about}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="mobileNumber"
                label="Mobile Number (Primary)"
                type="tel"
                fullWidth
                value={formData.mobileNumber}
                onChange={handleChange}
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="workNumber"
                label="Work Number (Primary)"
                type="tel"
                fullWidth
                value={formData.workNumber}
                onChange={handleChange}
                error={!!errors.workNumber}
                helperText={errors.workNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="faxNumber"
                label="Fax Number"
                type="tel"
                fullWidth
                value={formData.faxNumber}
                onChange={handleChange}
                error={!!errors.faxNumber}
                helperText={errors.faxNumber}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="branchId"
                label="Branch ID"
                fullWidth
                value={formData.branchId}
                onChange={handleChange}
                error={!!errors.branchId}
                helperText={errors.branchId}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="privysealAlias"
                label="PrivySeal Alias"
                fullWidth
                value={formData.privysealAlias}
                onChange={handleChange}
                error={!!errors.privysealAlias}
                helperText={errors.privysealAlias || 'optional (used by PP integration)'}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="registrationNumber"
                label="Registration Number"
                fullWidth
                value={formData.registrationNumber}
                onChange={handleChange}
                error={!!errors.registrationNumber}
                helperText={errors.registrationNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="vatNumber"
                label="VAT Number"
                fullWidth
                value={formData.vatNumber}
                onChange={handleChange}
                error={!!errors.vatNumber}
                helperText={errors.vatNumber}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="qualification"
                label="Qualification"
                fullWidth
                value={formData.qualification}
                onChange={handleChange}
                error={!!errors.qualification}
                helperText={errors.qualification}
              />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="profile.facebook"
                label="Facebook URL"
                fullWidth
                value={formData.profile.facebook}
                onChange={handleChange}
                error={!!errors.facebook}
                helperText={errors.facebook}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="dense"
                name="profile.twitter"
                label="Twitter URL"
                fullWidth
                value={formData.profile.twitter}
                onChange={handleChange}
                error={!!errors.twitter}
                helperText={errors.twitter}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                <Avatar src={imagePreview} sx={{ width: 100, height: 100, mb: 2 }} />
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="agent-image-upload"
                  type="file"
                  onChange={handleImageUpload}
                  ref={fileInputRef}
                />
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <label htmlFor="agent-image-upload">
                    <Button variant="outlined" component="span" startIcon={<CloudUpload />}>
                      Upload Profile Image
                    </Button>
                  </label>
                  {imagePreview && (
                    <IconButton color="error" onClick={removeImage} size="small">
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
                {errors.profilePicture && (
                  <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                    {errors.profilePicture}
                  </Typography>
                )}
                {formData.profilePicture && !errors.profilePicture && (
                  <Chip
                    label="Image uploaded"
                    color="success"
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1 }}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="publish-choice-label">After Save</InputLabel>
                <Select
                  labelId="publish-choice-label"
                  label="After Save"
                  value={publishChoice}
                  onChange={(e) => setPublishChoice(e.target.value)}
                >
                  <MenuItem value="none">Do nothing</MenuItem>
                  <MenuItem value="pp">Publish to PP</MenuItem>
                  <MenuItem value="website">Publish to Website</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>

      <DialogActions>
        <Button type="button" onClick={onClose}>
          Cancel
        </Button>
        {tabValue > 0 && (
          <Button type="button" onClick={handleBack}>
            Back
          </Button>
        )}
        <Button
          type="button"
          variant="contained"
          color={tabValue === 3 ? 'success' : 'primary'}
          onClick={handleNext}
        >
          {tabValue === 3 ? 'Submit' : 'Next'}
        </Button>
      </DialogActions>
    </Box>
  );
};

export default IndependantForm;